import React, { FC, Fragment } from 'react';
import { Grid, TableRow, TableCell } from '@material-ui/core';
import { times } from 'lodash';

import { LoaderComponents } from 'components';

interface Props {
  rows: number;
  sentinelRef: (node: Element) => void;
}

const AcceptedTableLoader: FC<Props> = ({ rows, sentinelRef }) => {
  const { Content } = LoaderComponents;

  return (
    <Fragment>
      {times(rows, rowIndex => (
        <TableRow ref={sentinelRef} key={rowIndex}>
          <TableCell colSpan={4}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <Content index={rowIndex} height={20} maxWidth={400} />
              </Grid>
            </Grid>
          </TableCell>
        </TableRow>
      ))}
    </Fragment>
  );
};

export default AcceptedTableLoader;
